import React from "react";
import { useNavigate, useMatch } from "react-router-dom";
import { Box } from "@chakra-ui/react";
import AnalystDetailView from "modules/analyst/containers/AnalystDetailView";

/**
 * Route page for /analyst/:id and /analyst/new.
 * Delegates all state and rendering to AnalystDetailContainer.
 * When the user navigates back to /analyst, AnalystListPage re-fetches the list.
 */
const AnalystPage: React.FC = () => {
  const navigate = useNavigate();
  const isNewRoute = useMatch("/analyst/new");
  const isCreatingNew = !!isNewRoute;

  const handleBack = () => navigate("/analyst");

  return (
    <Box width="100%" height="100vh" bg="gray.50">
      <AnalystDetailView isCreatingNew={isCreatingNew} onBack={handleBack} />
    </Box>
  );
};

export default AnalystPage;
